import { tv, type VariantProps } from 'tailwind-variants';
export type MlAccordionVariants = VariantProps<typeof mlAccordion>;

const mlAccordion = tv({
  base: '',
  slots: {
    accordionItemBase: 'w-full',
    accordionItemBody: 'overflow-hidden',
    icon: '',
  },
  variants: {
    intents: {
      default: {
        accordionItemBase: 'border-b-2 border-accordion',
      },
      nav: {
        accordionItemBase: '',
        accordionItemBody: 'px-8',
      },
    },
    open: {
      true: {
        icon: 'ease-[0.04, 0.62, 0.23, 0.98] rotate-180 transition-transform duration-[0.8s]',
      },
    },
  },
  compoundVariants: [],
});

export default mlAccordion;
